module.exports = __webpack_public_path__ + "img/Property 1=4x3, Property 2=TW - Taiwan (Republic of China).339d9b3d.svg";